import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getInvoiceReportReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.invoice_type_id) params.invoice_type_id = searchQuery.invoice_type_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.from_date) params.from_date = searchQuery.from_date;
    if (searchQuery.to_date) params.to_date = searchQuery.to_date;
    if (searchQuery.search_by) params.search_by = searchQuery.search_by;
    if (searchQuery.b2b_b2c) params.b2b_b2c = searchQuery.b2b_b2c;
    if (searchQuery.status_filter) params.status_filter = searchQuery.status_filter;
    if (searchQuery.search) params.search = searchQuery.search;

    return axiosInstance.get(apiEndpoints.GET_INVOICE_REPORT_API, { params });
}

export const getInvoiceAgingReportReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.invoice_type_id) params.invoice_type_id = searchQuery.invoice_type_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.as_on_date) params.as_on_date = searchQuery.as_on_date;
    if (searchQuery.aging_bucket && searchQuery.aging_bucket !== 'ALL') params.aging_bucket = searchQuery.aging_bucket;
    if (searchQuery.status_filter && searchQuery.status_filter !== 'ALL') params.status_filter = searchQuery.status_filter;
    if (searchQuery.search) params.search = searchQuery.search;
    if (searchQuery.sort_by) params.sort_by = searchQuery.sort_by;
    if (searchQuery.sort_order) params.sort_order = searchQuery.sort_order;

    return axiosInstance.get(apiEndpoints.GET_INVOICE_AGING_REPORT_API, { params });
}

export const exportInvoiceAgingReportReq = (params) => {
    return axiosInstance.get(apiEndpoints.GET_INVOICE_AGING_REPORT_API, {
        params: { ...params, export: 'excel' },
        responseType: 'blob'
    });
}

export const getInterestReportReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.invoice_type_id) params.invoice_type_id = searchQuery.invoice_type_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.from_date) params.from_date = searchQuery.from_date;
    if (searchQuery.to_date) params.to_date = searchQuery.to_date;
    if (searchQuery.search) params.search = searchQuery.search;

    return axiosInstance.get(apiEndpoints.GET_INTEREST_REPORT_API, { params });
}

export const exportInterestReportReq = (params) => {
    return axiosInstance.get(apiEndpoints.GET_INTEREST_REPORT_API, {
        params: { ...params, export: 'excel' },
        responseType: 'blob'
    });
}

export const getReceiptReportReq = (action) => {
    const searchQuery = action?.data || {};
    const params = { page: searchQuery.page || 1, limit: searchQuery.limit || 10 };
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.from_date) params.from_date = searchQuery.from_date;
    if (searchQuery.to_date) params.to_date = searchQuery.to_date;
    if (searchQuery.payment_mode && searchQuery.payment_mode !== 'ALL') params.payment_mode = searchQuery.payment_mode;
    if (searchQuery.status_filter && searchQuery.status_filter !== 'ALL') params.status_filter = searchQuery.status_filter;
    if (searchQuery.receipt_type && searchQuery.receipt_type !== 'ALL') params.receipt_type = searchQuery.receipt_type;
    if (searchQuery.search) params.search = searchQuery.search;
    return axiosInstance.get(apiEndpoints.GET_RECEIPT_REPORT_API, { params });
}

export const exportReceiptReportReq = (params) => {
    return axiosInstance.get(apiEndpoints.GET_RECEIPT_REPORT_API, {
        params: { ...params, export: 'excel' },
        responseType: 'blob'
    });
}

export const getCDNoteReportReq = (action) => {
    const searchQuery = action?.data || {};
    const params = { page: searchQuery.page || 1, limit: searchQuery.limit || 10 };
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.note_type && searchQuery.note_type !== 'ALL') params.note_type = searchQuery.note_type;
    if (searchQuery.invoice_type_id) params.invoice_type_id = searchQuery.invoice_type_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.from_date) params.from_date = searchQuery.from_date;
    if (searchQuery.to_date) params.to_date = searchQuery.to_date;
    if (searchQuery.status_filter && searchQuery.status_filter !== 'ALL') params.status_filter = searchQuery.status_filter;
    if (searchQuery.search) params.search = searchQuery.search;
    return axiosInstance.get(apiEndpoints.GET_CD_NOTE_REPORT_API, { params });
}

export const exportCDNoteReportReq = (params) => {
    return axiosInstance.get(apiEndpoints.GET_CD_NOTE_REPORT_API, {
        params: { ...params, export: 'excel' },
        responseType: 'blob'
    });
}

export const getGSTReportReq = (action) => {
    const searchQuery = action?.data || {};
    const params = { page: searchQuery.page || 1, limit: searchQuery.limit || 10 };
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.invoice_type_id) params.invoice_type_id = searchQuery.invoice_type_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.from_date) params.from_date = searchQuery.from_date;
    if (searchQuery.to_date) params.to_date = searchQuery.to_date;
    if (searchQuery.b2b_b2c && searchQuery.b2b_b2c !== 'ALL') params.b2b_b2c = searchQuery.b2b_b2c;
    if (searchQuery.search) params.search = searchQuery.search;
    return axiosInstance.get(apiEndpoints.GET_GST_REPORT_API, { params });
}

export const exportGSTReportReq = (params) => {
    return axiosInstance.get(apiEndpoints.GET_GST_REPORT_API, {
        params: { ...params, export: 'excel' },
        responseType: 'blob'
    });
}

export const getReconciliationReportReq = (action) => {
    const searchQuery = action?.data || {};
    const params = { page: searchQuery.page || 1, limit: searchQuery.limit || 10 };
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.as_on_date) params.as_on_date = searchQuery.as_on_date;
    if (searchQuery.only_difference) params.only_difference = searchQuery.only_difference;
    if (searchQuery.search) params.search = searchQuery.search;
    return axiosInstance.get(apiEndpoints.GET_RECONCILIATION_REPORT_API, { params });
}

export const exportReconciliationReportReq = (params) => {
    return axiosInstance.get(apiEndpoints.GET_RECONCILIATION_REPORT_API, {
        params: { ...params, export: 'excel' },
        responseType: 'blob'
    });
}

export const exportInvoiceReportReq = (params) => {
    return axiosInstance.get(apiEndpoints.GET_INVOICE_REPORT_API, {
        params: { ...params, export: 'excel' },
        responseType: 'blob'
    });
}
